import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../api/quarkusApi';

// Termos (templates) servidos pelo quarkus.
export function useTerms() {
  const navigate = useNavigate();

  const [terms, setTerms] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTerms = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/terms', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setTerms(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchTerms();
  }, [fetchTerms]);

  return { terms, isLoading, error, refetch: fetchTerms };
}
